import React from 'react';
import * as PropTypes from 'prop-types';
import {InputContainerStyle, InputStyle, LockedIconStyle} from './input.styled';

const LockedIcon = props => (
	<div className={props.className}>
		<svg xmlns="http://www.w3.org/2000/svg" width={'9px'} height={'10px'} viewBox="0 0 9 10">
			<path
				fill={'#757575'}
				fillRule="evenodd"
				d="M1.667 8.333h5V5h-5v3.333zm2.5-6.666c.919 0 1.666.747 1.666 1.666H2.5c0-.919.748-1.666 1.667-1.666zM7.5 3.333A3.337 3.337 0 0 0 4.167 0 3.337 3.337 0 0 0 .833 3.333.834.834 0 0 0 0 4.167v5c0 .46.373.833.833.833H7.5c.46 0 .833-.372.833-.833v-5a.834.834 0 0 0-.833-.834z"
			/>
		</svg>
	</div>
);

export const HoursInput = props => {
	const inputState = props.locked
		? ' locked'
		: props.disabled
		? ''
		: props.hasError
		? ' error'
		: props.nonWorkingDay
		? ' non-working-day'
		: '';

	return (
		<InputContainerStyle>
			<InputStyle
				className={inputState}
				type={'text'}
				placeholder={props.placeholder}
				value={props.value}
				onFocus={e => {
					e.preventDefault();
					e.target.select();
					props.onClick(e);
				}}
				onBlur={props.onBlur}
				disabled={props.disabled || props.locked}
			></InputStyle>
			{props.locked ? (
				<LockedIconStyle>
					<LockedIcon className="locked"></LockedIcon>
				</LockedIconStyle>
			) : null}
		</InputContainerStyle>
	);
};

LockedIcon.propTypes = {
	className: PropTypes.string,
};

HoursInput.propTypes = {
	/**
	 * Information when no value has been set yet.
	 */
	placeholder: PropTypes.string,
	/**
	 * Disable the input the user can't insert a new value or edit the current one.
	 */
	disabled: PropTypes.bool,
	/**
	 * Same as disabled, plus a visual indicator.
	 */
	locked: PropTypes.bool,
	/**
	 * When the input is focused the current value is selected. And the cursor ready to receive text input
	 */
	onClick: PropTypes.func,
	/**
	 * On blue the input parse the value to change it to the hours format (1h 30m).
	 * If this succed then it calls the mutation from the parent, else it keep the value typed and set the input as invalid
	 */
	onBlur: PropTypes.func,
	/**
	 * Indicator to show that the input is in an invalid state
	 */
	hasError: PropTypes.bool,
	/**
	 * Action to execute if the validation is successful
	 */
	mutation: PropTypes.func,
	/**
	 * Value of the input
	 */
	value: PropTypes.string,
	/**
	 * State from the timesheet. It indicates if the time input belongs to a user's non working day
	 */
	nonWorkingDay: PropTypes.bool,
};

HoursInput.defaultProps = {
	disabled: false,
	locked: false,
	hasError: false,
	nonWorkingDay: false,
};
